module.exports = __webpack_public_path__ + "static/media/drag_asset.b4e9db5d.mp4";